export default "__VITE_ASSET__dda20ffa__"